export function getApiBaseUrl(host: string | null) {
  const protocol = `${process.env.NEXT_PUBLIC_HTTPS}`
  const musShptst = `${process.env.NEXT_PUBLIC_MUS_SHPTST}`
  const musTest = `${process.env.NEXT_PUBLIC_MUS_TEST}`
  const musDev = `${process.env.NEXT_PUBLIC_MUS_BETA}`
  const musBeta = `${process.env.NEXT_PUBLIC_MUS_BETA}`
  const mus = `${process.env.NEXT_PUBLIC_MUS}`
  const venShptst = `${process.env.NEXT_PUBLIC_VEN_SHPTST}`
  const venTest = `${process.env.NEXT_PUBLIC_VEN_TEST}`
  const venDev = `${process.env.NEXT_PUBLIC_VEN_DEV}`
  const ven = `${process.env.NEXT_PUBLIC_VEN}`
  const apiPath = `${process.env.NEXT_PUBLIC_API_PATH}`

  const isProduction = process.env.NODE_ENV === "production"

  if (isProduction) {
    // server side we get the host from the proxy header, but on the client via window.origin
    if (host && host === mus || host === "musix.com" || host === "https://www.musix.com") {
      return protocol + mus + apiPath
    }
    if (host && (host === musTest || host.includes(musTest))) {
      return protocol + musTest + apiPath
    }
    else if (host && (host === ven || host === "venoa.com" || host === "https://www.venoa.com")) {
      return protocol + ven + apiPath
    }
    else if (host && (host === venShptst || host === `www.${venShptst}`)) {
      return protocol + venShptst + apiPath
    }
    else if (host && (host === venTest || host.includes(venTest))) {
      return protocol + venTest + apiPath
    }
    else if (host && (host === musDev || host.includes(musDev))) {
      return protocol + musDev + apiPath
    }
    else if (host && (host === musBeta || host.includes(musBeta))) {
      return protocol + musBeta + apiPath
    }
    else if (host && (host === venDev || host.includes(venDev))) {
      return protocol + venDev + apiPath
    }
    else {
      // should never be the case, returned for ts-linting
      return "";
    }
  }
  else {
    // local data source fallback - DEV
    if (host && (host.includes("localhost.corp.invoca.ch"))) {
      // ----------------------------------------------------------------------------
      const hostWithoutPort = host.split(".ch:")[0]
      const portPart = host.split(".ch:")[1]
      const port = portPart.slice(0, portPart.length - 1)
      const protocol = hostWithoutPort.startsWith("http") ? "" : "http://"
      // ----------------------------------------------------------------------------
      return `${protocol}${hostWithoutPort}.ch:${port}5${apiPath}`;
    }
    if (host && host.includes("localhost")) {
      // For localhost:3000, outside the system development
      return protocol + mus + apiPath
    }

    // server side we get the host from the proxy header, but on the client via window.origin
    else if (host && (host === musTest || host.includes(musTest))) {
      return protocol + musTest + apiPath
    } else if (host && (host === mus || host.includes(mus))) {
      return protocol + mus + apiPath
    } else if (host && (host === venTest || host.includes(venTest))) {
      return protocol + venTest + apiPath
    } else if (host && (host === ven || host.includes(ven))) {
      return protocol + ven + apiPath
    } else if (host && (host === musDev || host.includes(musDev))) {
      return protocol + musDev + apiPath
    }
    else if (host && (host === musBeta || host.includes(musBeta))) {
      return protocol + musBeta + apiPath
    }
    else if (host && (host === venDev || host.includes(venDev))) {
      return protocol + venDev + apiPath
    } else {
      // should never be the case, returned for ts-linting
      return "";
    }
  }
}